module.exports = __webpack_public_path__ + "static/media/wasabi-logo.4ff7bf85.svg";